import {post} from '@/utils/request';

//获取所有菜单
export async function menuelist(params) {
    return post('/menu/getList', params, true)
}
//新增保存
export async function savemenue(params) {
    return post('/menu/addMenu', params, true)
}
//修改保存
export async function update(params) {
    return post('/menu/updateMenu', params, true)
}
// 删除
export async function del(params) {
    return post('/menu/deleteMenu', params, true);
}
//编辑信息
export async function MenuInfo(params) {
    return post('/menu/getMenuInfo', params, true);
}
//接口配置
export async function getMenuInterfaceInfo(params) {
    return post('/menu/getMenuInterfaceInfo', params, true);
}
//保存
export async function saveMenuInterface(params) {
    return post('/menu/saveMenuInterface', params, true);
}


